

// import React, { useState, useEffect, useRef } from 'react';
// import { 
//   Eye, MoreHorizontal, Filter, Plus, Search, 
//   Trash2, Edit, ChevronLeft, ChevronRight
// } from 'lucide-react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import SummaryApi from '../common/SummaryApi';
// import AllProductsSkeleton from '../panelComponents/AllProductsComponent/AllProductsSkeleton';

// const AllProducts = () => {
//   const navigate = useNavigate();
//   const dropdownRef = useRef(null);

//   const [products, setProducts] = useState([]);
//   const [topCategories, setTopCategories] = useState([]);
//   const [subCategories, setSubCategories] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [loading, setLoading] = useState(false);
  
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);
//   const [showFilters, setShowFilters] = useState(true);

//   // Advanced Menu State
//   const [menuConfig, setMenuConfig] = useState({
//     isOpen: false,
//     productId: null,
//     top: 0,
//     left: 0,
//     openUpward: false
//   });

//   const [filters, setFilters] = useState({
//     topCategory: '',
//     subCategory: '',
//     status: '',
//     stockStatus: '',
//   });

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Bearer ${token}` } : {};

//       const [prodRes, topRes, subRes] = await Promise.all([
//         axios.get(SummaryApi.getAllProducts.url, { headers }),
//         axios.get(SummaryApi.getAllTopCategories.url, { headers }),
//         axios.get(SummaryApi.getAllSubCategories.url, { headers })
//       ]);

//       setProducts(prodRes.data.products || []);
//       setTopCategories(topRes.data.data || topRes.data.topCategory || []);
//       setSubCategories(subRes.data.data || subRes.data.subCategory || []);
//     } catch (err) {
//       console.error("Failed to fetch data from server");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { 
//     fetchData(); 
//     const handleScrollOrResize = () => setMenuConfig(prev => ({ ...prev, isOpen: false }));
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setMenuConfig(prev => ({ ...prev, isOpen: false }));
//       }
//     };

//     window.addEventListener("scroll", handleScrollOrResize, true);
//     window.addEventListener("resize", handleScrollOrResize);
//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       window.removeEventListener("scroll", handleScrollOrResize, true);
//       window.removeEventListener("resize", handleScrollOrResize);
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     let result = [...products];
//     if (searchQuery) {
//       const s = searchQuery.toLowerCase();
//       result = result.filter(item => (item.productName || item.name || "").toLowerCase().includes(s));
//     }
//     if (filters.topCategory) {
//       result = result.filter(item => (item.topCategory?.name || item.topCategory) === filters.topCategory);
//     }
//     if (filters.subCategory) {
//       result = result.filter(item => (item.subCategory?.name || item.subCategory) === filters.subCategory);
//     }
//     if (filters.status) result = result.filter(item => item.status === filters.status);
    
//     setFilteredData(result);
//     setCurrentPage(1);
//   }, [products, searchQuery, filters]);

//   // --- SMART POSITIONING LOGIC ---
//   const handleOpenMenu = (e, product) => {
//     e.stopPropagation();
//     const rect = e.currentTarget.getBoundingClientRect();
//     const menuHeight = 160; // Approximate height of the dropdown
//     const spaceBelow = window.innerHeight - rect.bottom;
//     const shouldOpenUpward = spaceBelow < menuHeight;

//     setMenuConfig({
//       isOpen: true,
//       productId: product._id,
//       // If opening upward, subtract menu height from top position
//       top: shouldOpenUpward ? rect.top - menuHeight : rect.bottom,
//       left: rect.right - 160, // Aligning to the right of the button
//       openUpward: shouldOpenUpward
//     });
//   };

//   const handleDelete = async (id) => {
//     if(window.confirm("Permanent delete this product?")) {
//       setProducts(products.filter(p => p._id !== id));
//       setMenuConfig(prev => ({ ...prev, isOpen: false }));
//     }
//   };

//   const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//   const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

//   if (loading) return <AllProductsSkeleton />;

//   return (
//     <div className="min-h-screen bg-gray-50/50 font-sans">
      
//       {/* Header */}
//       <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
//         <div>
//             <h1 className="text-2xl font-bold text-gray-900">Products Catalog</h1>
//             <p className="text-sm text-gray-500 mt-1">Total {products.length} items listed.</p>
//         </div>
//         <button onClick={() => navigate("upload", { state: { topCategories, subCategories } })} className="px-5 py-2.5 bg-blue-600 text-white rounded-xl flex items-center gap-2 hover:bg-blue-700 shadow-lg shadow-blue-200 transition-all font-semibold">
//             <Plus size={18} /> Add Product
//         </button>
//       </div>

//       {/* Filters */}
//       <div className="bg-white rounded-2xl shadow-sm border border-gray-200 mb-6 overflow-hidden">
//         <div className="p-4 flex flex-col md:flex-row gap-4">
//             <div className="relative flex-1">
//                 <Search className="absolute left-3 top-2.5 text-gray-400" size={18} />
//                 <input type="text" placeholder="Search product name..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border-none rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20" />
//             </div>
//             <button onClick={() => setShowFilters(!showFilters)} className={`px-4 py-2.5 rounded-xl border flex items-center gap-2 text-sm font-bold transition-all ${showFilters ? 'bg-blue-50 border-blue-100 text-blue-600' : 'bg-white text-gray-600'}`}>
//                 <Filter size={16}/> Filters
//             </button>
//         </div>

//         {showFilters && (
//             <div className="p-4 bg-gray-50/50 border-t grid grid-cols-1 md:grid-cols-4 gap-4 animate-in slide-in-from-top-2 duration-300">
//                 <select value={filters.topCategory} onChange={(e) => setFilters({...filters, topCategory: e.target.value, subCategory: ''})} className="p-2.5 border rounded-xl text-xs bg-white outline-none">
//                     <option value="">Top Category: All</option>
//                     {topCategories.map(cat => <option key={cat._id} value={cat.name}>{cat.name}</option>)}
//                 </select>
//                 <select value={filters.subCategory} onChange={(e) => setFilters({...filters, subCategory: e.target.value})} className="p-2.5 border rounded-xl text-xs bg-white outline-none" disabled={!filters.topCategory}>
//                     <option value="">Sub Category: All</option>
//                     {subCategories.filter(sub => (sub.topCategory?.name || sub.topCategory) === filters.topCategory).map(sub => <option key={sub._id} value={sub.name}>{sub.name}</option>)}
//                 </select>
//                 <select value={filters.status} onChange={(e) => setFilters({...filters, status: e.target.value})} className="p-2.5 border rounded-xl text-xs bg-white outline-none">
//                     <option value="">Status: All</option>
//                     <option value="Published">Published</option>
//                     <option value="Draft">Draft</option>
//                 </select>
//                 <button onClick={() => setFilters({topCategory:'', subCategory:'', status:'', stockStatus:''})} className="text-xs font-bold text-red-500 hover:bg-red-50 rounded-xl transition-all">Reset Filters</button>
//             </div>
//         )}
//       </div>

//       {/* Table */}
//       <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
//         <div className="overflow-x-auto">
//             <table className="w-full text-left text-sm">
//                 <thead className="bg-gray-50/80 border-b text-gray-400 font-bold uppercase text-[10px] tracking-widest">
//                     <tr>
//                         <th className="px-6 py-5">Product Details</th>
//                         <th className="px-6 py-5">Category Information</th>
//                         <th className="px-6 py-5">Inventory</th>
//                         <th className="px-6 py-5">Status</th>
//                         <th className="px-6 py-5 text-center">Actions</th>
//                     </tr>
//                 </thead>
//                 <tbody className="divide-y divide-gray-100">
//                     {paginatedData.map((product) => (
//                         <tr key={product._id} className="hover:bg-gray-50/50 transition-colors group">
//                             <td className="px-6 py-4">
//                                 <div className="flex items-center gap-4">
//                                     <div className="h-14 w-14 rounded-xl bg-gray-100 overflow-hidden border border-gray-100 flex-shrink-0">
//                                         <img src={product.previewImage || 'https://via.placeholder.com/100?text=No+Image'} alt="" className="h-full w-full object-cover" />
//                                     </div>
//                                     <div className="min-w-0">
//                                         <div className="font-bold text-gray-900 truncate max-w-[180px]">{product.productName || "Untitled"}</div>
//                                         <div className="text-[10px] text-gray-400 font-bold uppercase tracking-tight mt-0.5">{product.variantCount || 0} Colors • {product.brand || 'Generic'}</div>
//                                     </div>
//                                 </div>
//                             </td>
//                             <td className="px-6 py-4">
//                                 <div className="text-gray-900 font-semibold">{product.topCategory?.name || product.topCategory || '-'}</div>
//                                 <div className="text-xs text-gray-400 mt-0.5">{product.subCategory?.name || product.subCategory || '-'}</div>
//                             </td>
//                             <td className="px-6 py-4">
//                                 <div className="text-gray-900 font-bold text-lg">{product.totalStock ?? 0}</div>
//                                 <div className="text-[9px] text-gray-400 font-black uppercase tracking-widest">Items Total</div>
//                             </td>
//                             <td className="px-6 py-4">
//                                 <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border ${product.status === 'Published' ? 'bg-green-50 text-green-600 border-green-100' : 'bg-gray-50 text-gray-500 border-gray-100'}`}>
//                                     <span className={`h-1.5 w-1.5 rounded-full ${product.status === 'Published' ? 'bg-green-500' : 'bg-gray-400'}`}></span>
//                                     {product.status || 'Draft'}
//                                 </span>
//                             </td>
//                             <td className="px-6 py-4 text-center">
//                                 <button onClick={(e) => handleOpenMenu(e, product)} className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-400 group-hover:text-gray-900">
//                                     <MoreHorizontal size={20} />
//                                 </button>
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         </div>

//         {/* Footer */}
//         <div className="p-6 border-t flex flex-col sm:flex-row justify-between items-center gap-4 bg-gray-50/30">
//             <span className="text-xs font-bold text-gray-400 uppercase tracking-widest">Page {currentPage} of {totalPages || 1}</span>
//             <div className="flex gap-2">
//                 <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="p-2 border border-gray-200 rounded-xl bg-white disabled:opacity-30 hover:bg-gray-50 transition-all"><ChevronLeft size={18}/></button>
//                 <button disabled={currentPage >= totalPages} onClick={() => setCurrentPage(p => p + 1)} className="p-2 border border-gray-200 rounded-xl bg-white disabled:opacity-30 hover:bg-gray-50 transition-all"><ChevronRight size={18}/></button>
//             </div>
//         </div>
//       </div>

//       {/* --- FLOATING DYNAMIC MENU --- */}
//       {menuConfig.isOpen && (
//         <div 
//             ref={dropdownRef}
//             className="fixed z-[9999] w-44 bg-white border border-gray-100 rounded-2xl shadow-2xl py-2 animate-in fade-in zoom-in-95 duration-150"
//             style={{ 
//               top: `${menuConfig.top}px`, 
//               left: `${menuConfig.left}px` 
//             }}
//         >
//             <button className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-600 hover:bg-gray-50 transition-colors font-medium">
//                 <Eye size={16} className="text-gray-400"/> View Details
//             </button>
//             <button 
//                 onClick={() => {
//                   setMenuConfig(prev => ({ ...prev, isOpen: false }));
//                   navigate(`upload/${menuConfig.productId}`, { state: { topCategories, subCategories } });
//                 }}
//                 className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-600 hover:bg-gray-50 transition-colors font-medium"
//             >
//                 <Edit size={16} className="text-gray-400"/> Edit Product
//             </button>
//             <div className="h-px bg-gray-50 my-1 mx-2"></div>
//             <button 
//                 onClick={() => handleDelete(menuConfig.productId)}
//                 className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 transition-colors font-bold"
//             >
//                 <Trash2 size={16}/> Delete Item
//             </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AllProducts;

// import React, { useState, useEffect, useRef } from 'react';
// import { 
//   Eye, MoreHorizontal, Filter, Plus, Search, 
//   Trash2, Edit
// } from 'lucide-react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import SummaryApi from '../common/SummaryApi';
// import AllProductsSkeleton from '../panelComponents/SkeletonLoadings/AllProductsSkeleton';
// import Pagination from '../helpers/Pagination';

// const AllProducts = () => {
//   const navigate = useNavigate();
//   const dropdownRef = useRef(null);

//   const [products, setProducts] = useState([]);
//   const [topCategories, setTopCategories] = useState([]);
//   const [subCategories, setSubCategories] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [loading, setLoading] = useState(false);
  
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);
//   const [showFilters, setShowFilters] = useState(true);

//   const [menuConfig, setMenuConfig] = useState({
//     isOpen: false,
//     productId: null,
//     top: 0,
//     left: 0,
//     openUpward: false
//   });

//   const [filters, setFilters] = useState({
//     topCategory: '',
//     subCategory: '',
//     status: '',
//     stockStatus: '',
//   });

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Bearer ${token}` } : {};

//       const [prodRes, topRes, subRes] = await Promise.all([
//         axios.get(SummaryApi.getAllProducts.url, { headers }),
//         axios.get(SummaryApi.getAllTopCategories.url, { headers }),
//         axios.get(SummaryApi.getAllSubCategories.url, { headers })
//       ]);

//       // Using your expanded list for testing pagination
//       const rawProducts = prodRes.data.products || [];
//       const expandedProducts = Array(50).fill(rawProducts).flat();
//       setProducts(expandedProducts);
      
//       setTopCategories(topRes.data.data || topRes.data.topCategory || []);
//       setSubCategories(subRes.data.data || subRes.data.subCategory || []);
//     } catch (err) {
//       console.error("Failed to fetch data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => { 
//     fetchData(); 
//     const handleScrollOrResize = () => setMenuConfig(prev => ({ ...prev, isOpen: false }));
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setMenuConfig(prev => ({ ...prev, isOpen: false }));
//       }
//     };
//     window.addEventListener("scroll", handleScrollOrResize, true);
//     window.addEventListener("resize", handleScrollOrResize);
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       window.removeEventListener("scroll", handleScrollOrResize, true);
//       window.removeEventListener("resize", handleScrollOrResize);
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     let result = [...products];
//     if (searchQuery) {
//       const s = searchQuery.toLowerCase();
//       result = result.filter(item => (item.productName || "").toLowerCase().includes(s));
//     }
//     if (filters.topCategory) {
//       result = result.filter(item => (item.topCategory?.name || item.topCategory) === filters.topCategory);
//     }
//     if (filters.subCategory) {
//       result = result.filter(item => (item.subCategory?.name || item.subCategory) === filters.subCategory);
//     }
//     if (filters.status) result = result.filter(item => item.status === filters.status);
//     setFilteredData(result);
//     setCurrentPage(1);
//   }, [products, searchQuery, filters]);

//   const handleOpenMenu = (e, product) => {
//     e.stopPropagation();
//     const rect = e.currentTarget.getBoundingClientRect();
//     const menuHeight = 160;
//     const spaceBelow = window.innerHeight - rect.bottom;
//     const shouldOpenUpward = spaceBelow < menuHeight;

//     setMenuConfig({
//       isOpen: true,
//       productId: product._id,
//       top: shouldOpenUpward ? rect.top - menuHeight : rect.bottom,
//       left: rect.right - 160,
//       openUpward: shouldOpenUpward
//     });
//   };

//   const handleDelete = async (id) => {
//     if(window.confirm("Are you sure you want to permanently delete this product?")) {
//       try {
//         const token = localStorage.getItem('token');
//         const res = await axios.delete(SummaryApi.deleteProduct.url(id), {
//           headers: { Authorization: `Bearer ${token}` }
//         });
        
//         if(res.data.success) {
//           setProducts(prev => prev.filter(p => p._id !== id));
//           setMenuConfig(prev => ({ ...prev, isOpen: false }));
//           alert("Product deleted successfully");
//         }
//       } catch (err) {
//         alert(err.response?.data?.message || "Delete failed");
//       }
//     }
//   };

//   // const totalPages = Math.ceil(filteredData.length / itemsPerPage);
//   const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

//   if (loading) return <AllProductsSkeleton />;

//   return (
//     <div className="min-h-screen bg-gray-50/50 font-sans p-4">
//       {/* Header */}
//       <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
//         <div>
//             <h1 className="text-2xl font-bold text-gray-900">All Products</h1>
//             <p className="text-sm text-gray-500 mt-1">Total {filteredData.length} items listed.</p>
//         </div>
//         <button onClick={() => navigate("upload", { state: { topCategories, subCategories } })} className="px-5 py-2.5 bg-blue-600 text-white rounded-xl flex items-center gap-2 hover:bg-blue-700 shadow-lg transition-all font-semibold">
//             <Plus size={18} /> Add Product
//         </button>
//       </div>

//       {/* Filters Bar */}
//       <div className="bg-white rounded-2xl shadow-sm border border-gray-200 mb-6 overflow-hidden">
//         <div className="p-4 flex flex-col md:flex-row gap-4">
//             <div className="relative flex-1">
//                 <Search className="absolute left-3 top-2.5 text-gray-400" size={18} />
//                 <input type="text" placeholder="Search product name..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border-none rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500/20" />
//             </div>
//             <button onClick={() => setShowFilters(!showFilters)} className={`px-4 py-2.5 rounded-xl border flex items-center gap-2 text-sm font-bold transition-all ${showFilters ? 'bg-blue-50 border-blue-100 text-blue-600' : 'bg-white text-gray-600'}`}>
//                 <Filter size={16}/> Filters
//             </button>
//         </div>

//         {showFilters && (
//             <div className="p-4 bg-gray-50/50 border-t grid grid-cols-1 md:grid-cols-4 gap-4 animate-in slide-in-from-top-2">
//                 <select value={filters.topCategory} onChange={(e) => setFilters({...filters, topCategory: e.target.value, subCategory: ''})} className="p-2.5 border rounded-xl text-xs bg-white outline-none">
//                     <option value="">Top Category: All</option>
//                     {topCategories.map(cat => <option key={cat._id} value={cat.name}>{cat.name}</option>)}
//                 </select>
//                 <select value={filters.subCategory} onChange={(e) => setFilters({...filters, subCategory: e.target.value})} className="p-2.5 border rounded-xl text-xs bg-white outline-none" disabled={!filters.topCategory}>
//                     <option value="">Sub Category: All</option>
//                     {subCategories.filter(sub => (sub.topCategory?.name || sub.topCategory) === filters.topCategory).map(sub => <option key={sub._id} value={sub.name}>{sub.name}</option>)}
//                 </select>
//                 <select value={filters.status} onChange={(e) => setFilters({...filters, status: e.target.value})} className="p-2.5 border rounded-xl text-xs bg-white outline-none">
//                     <option value="">Status: All</option>
//                     <option value="Published">Published</option>
//                     <option value="Draft">Draft</option>
//                 </select>
//                 <button onClick={() => setFilters({topCategory:'', subCategory:'', status:'', stockStatus:''})} className="text-xs font-bold text-red-500 hover:bg-red-50 rounded-xl transition-all">Reset Filters</button>
//             </div>
//         )}
//       </div>

//       {/* Table Section */}
//       <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
//         <div className="overflow-x-auto">
//             <table className="w-full text-left text-sm">
//                 <thead className="bg-gray-50/80 border-b text-gray-400 font-bold uppercase text-[10px] tracking-widest">
//                     <tr>
//                         <th className="px-6 py-5">Product Details</th>
//                         <th className="px-6 py-5">Category Information</th>
//                         <th className="px-6 py-5">Inventory</th>
//                         <th className="px-6 py-5">Status</th>
//                         <th className="px-6 py-5 text-center">Actions</th>
//                     </tr>
//                 </thead>
//                 <tbody className="divide-y divide-gray-100">
//                     {paginatedData.map((product, idx) => (
//                         <tr key={product._id + idx} className="hover:bg-gray-50/50 transition-colors group">
//                             <td className="px-6 py-4">
//                                 <div className="flex items-center gap-4">
//                                     <div className="h-14 w-14 rounded-xl bg-gray-100 overflow-hidden border border-gray-100 flex-shrink-0">
//                                         <img src={product.previewImage || 'https://via.placeholder.com/100?text=No+Image'} alt="" className="h-full w-full object-cover" />
//                                     </div>
//                                     <div className="min-w-0">
//                                         <div className="font-bold text-gray-900 truncate max-w-[180px]">{product.productName || "Untitled"}</div>
//                                         <div className="text-[10px] text-gray-400 font-bold uppercase tracking-tight mt-0.5">{product.variantCount || 0} Colors • {product.brand || 'Generic'}</div>
//                                     </div>
//                                 </div>
//                             </td>
//                             <td className="px-6 py-4">
//                                 <div className="text-gray-900 font-semibold">{product.topCategory?.name || product.topCategory || '-'}</div>
//                                 <div className="text-xs text-gray-400 mt-0.5">{product.subCategory?.name || product.subCategory || '-'}</div>
//                             </td>
//                             <td className="px-6 py-4">
//                                 <div className="text-gray-900 font-bold text-lg">{product.totalStock ?? 0}</div>
//                                 <div className="text-[9px] text-gray-400 font-black uppercase tracking-widest">Items Total</div>
//                             </td>
//                             <td className="px-6 py-4">
//                                 <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border ${product.status === 'Published' ? 'bg-green-50 text-green-600 border-green-100' : 'bg-gray-50 text-gray-500 border-gray-100'}`}>
//                                     <span className={`h-1.5 w-1.5 rounded-full ${product.status === 'Published' ? 'bg-green-500' : 'bg-gray-400'}`}></span>
//                                     {product.status || 'Draft'}
//                                 </span>
//                             </td>
//                             <td className="px-6 py-4 text-center">
//                                 <button onClick={(e) => handleOpenMenu(e, product)} className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-400 group-hover:text-gray-900">
//                                     <MoreHorizontal size={20} />
//                                 </button>
//                             </td>
//                         </tr>
//                     ))}
//                 </tbody>
//             </table>
//         </div>

//         {/* --- UPDATED FOOTER WITH PROFESSIONAL PAGINATION --- */}
//         {/* <div className="p-6 border-t flex flex-col sm:flex-row justify-between items-center gap-4 bg-gray-50/30">
//             <div className="text-xs font-bold text-gray-400 uppercase tracking-widest">
//                 Showing {((currentPage - 1) * itemsPerPage) + 1} - {Math.min(currentPage * itemsPerPage, filteredData.length)} of {filteredData.length}
//             </div>
            
//             <Pagination 
//               totalPages={totalPages} 
//               currentPage={currentPage} 
//               onPageChange={(page) => setCurrentPage(page)} 
//             />
//         </div> */}

// <div className="p-6 border-t bg-gray-50/30">
//     <Pagination 
//       totalItems={filteredData.length} 
//       itemsPerPage={itemsPerPage} 
//       currentPage={currentPage} 
//       onPageChange={(page) => setCurrentPage(page)} 
//     />
// </div>
//       </div>

//       {/* Floating Menu */}
//       {menuConfig.isOpen && (
//         <div 
//             ref={dropdownRef}
//             className="fixed z-[9999] w-44 bg-white border border-gray-100 rounded-2xl shadow-2xl py-2 animate-in fade-in zoom-in-95 duration-150"
//             style={{ top: `${menuConfig.top}px`, left: `${menuConfig.left}px` }}
//         >
//             <button 
//                 onClick={() => {
//                   setMenuConfig(prev => ({ ...prev, isOpen: false }));
//                   navigate(`upload/${menuConfig.productId}`, { state: { topCategories, subCategories, readOnly: true } });
//                 }}
//                 className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-600 hover:bg-gray-50 font-medium"
//             >
//                 <Eye size={16} className="text-gray-400"/> View Details
//             </button>
//             <button 
//                 onClick={() => {
//                   setMenuConfig(prev => ({ ...prev, isOpen: false }));
//                   navigate(`upload/${menuConfig.productId}`, { state: { topCategories, subCategories, readOnly: false } });
//                 }}
//                 className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-600 hover:bg-gray-50 font-medium"
//             >
//                 <Edit size={16} className="text-gray-400"/> Edit Product
//             </button>
//             <div className="h-px bg-gray-50 my-1 mx-2"></div>
//             <button onClick={() => handleDelete(menuConfig.productId)} className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 font-bold">
//                 <Trash2 size={16}/> Delete Item
//             </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AllProducts;

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { 
  Eye, MoreHorizontal, Filter, Plus, Search, 
  Trash2, Edit
} from 'lucide-react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import SummaryApi from '../common/SummaryApi';
import AllProductsSkeleton from '../panelComponents/SkeletonLoadings/AllProductsSkeleton';
import Pagination from '../helpers/Pagination';
import SelectDropdown from '../customStyles/SelectDropdown';
import api from '../common/apiClient';

const AllProducts = () => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const [products, setProducts] = useState([]);
  const [topCategories, setTopCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [showFilters, setShowFilters] = useState(true);

  const [menuConfig, setMenuConfig] = useState({
    isOpen: false,
    productId: null,
    top: 0,
    left: 0,
    openUpward: false
  });

  const [filters, setFilters] = useState({
    topCategory: '',
    subCategory: '',
    status: '',
    stockStatus: '',
  });

  // Static options for status dropdown
  const statusOptions = [
    { id: 'Published', label: 'Published' },
    { id: 'Draft', label: 'Draft' }
  ];

  const fetchData = async () => {
    setLoading(true);
    try {

      const [prodRes, topRes, subRes] = await Promise.all([
        api.get(SummaryApi.getAllProducts.url),
        api.get(SummaryApi.getAllTopCategories.url),
        api.get(SummaryApi.getAllSubCategories.url)
      ]);

      const rawProducts = prodRes.data.products || [];
      // Note: Kept expanded logic for testing as per your original code
      setProducts(rawProducts);
      
      setTopCategories(topRes.data.data || topRes.data.topCategory || []);
      setSubCategories(subRes.data.data || subRes.data.subCategory || []);
    } catch (err) {
      console.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { 
    fetchData(); 
    const handleScrollOrResize = () => setMenuConfig(prev => ({ ...prev, isOpen: false }));
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setMenuConfig(prev => ({ ...prev, isOpen: false }));
      }
    };
    window.addEventListener("scroll", handleScrollOrResize, true);
    window.addEventListener("resize", handleScrollOrResize);
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      window.removeEventListener("scroll", handleScrollOrResize, true);
      window.removeEventListener("resize", handleScrollOrResize);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    let result = [...products];
    if (searchQuery) {
      const s = searchQuery.toLowerCase();
      result = result.filter(item => (item.productName || "").toLowerCase().includes(s));
    }
    if (filters.topCategory) {
      result = result.filter(item => (item.topCategory?.name || item.topCategory) === filters.topCategory);
    }
    if (filters.subCategory) {
      result = result.filter(item => (item.subCategory?.name || item.subCategory) === filters.subCategory);
    }
    if (filters.status) result = result.filter(item => item.status === filters.status);
    setFilteredData(result);
    setCurrentPage(1);
  }, [products, searchQuery, filters]);

  // Memoized subcategories based on selected Top Category
  const filteredSubOptions = useMemo(() => {
    if (!filters.topCategory) return [];
    return subCategories.filter(sub => (sub.topCategory?.name || sub.topCategory) === filters.topCategory);
  }, [subCategories, filters.topCategory]);

  const handleOpenMenu = (e, product) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    const menuHeight = 160;
    const spaceBelow = window.innerHeight - rect.bottom;
    const shouldOpenUpward = spaceBelow < menuHeight;

    setMenuConfig({
      isOpen: true,
      productId: product._id,
      top: shouldOpenUpward ? rect.top - menuHeight : rect.bottom,
      left: rect.right - 160,
      openUpward: shouldOpenUpward
    });
  };

  const handleDelete = async (id) => {
    if(window.confirm("Are you sure you want to permanently delete this product?")) {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.delete(SummaryApi.deleteProduct.url(id), {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if(res.data.success) {
          setProducts(prev => prev.filter(p => p._id !== id));
          setMenuConfig(prev => ({ ...prev, isOpen: false }));
          alert("Product deleted successfully");
        }
      } catch (err) {
        alert(err.response?.data?.message || "Delete failed");
      }
    }
  };

  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  if (loading) return <AllProductsSkeleton />;

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
        <div>
            <h1 className="text-2xl font-bold text-gray-900">All Products</h1>
            <p className="text-sm text-gray-500 mt-1">Total {filteredData.length} items listed.</p>
        </div>
        <button onClick={() => navigate("upload", { state: { topCategories, subCategories } })} className="px-5 py-2.5 bg-blue-600 text-white rounded-xl flex items-center gap-2 hover:bg-blue-700 shadow-lg transition-all font-semibold">
            <Plus size={18} /> Add Product
        </button>
      </div>

      {/* Filters Bar */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6 overflow-hidden">
        <div className="p-4 flex flex-col md:flex-row gap-4">
            <div className="relative flex-1">
                <Search className="absolute left-3 top-2.5 text-gray-400" size={18} />
                <input type="text" placeholder="Search product name..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border-none rounded-lg text-sm outline-none focus:ring-2 focus:ring-blue-500/20" />
            </div>
            <button onClick={() => setShowFilters(!showFilters)} className={`px-4 py-2.5 rounded-lg border flex items-center gap-2 text-sm font-bold transition-all ${showFilters ? 'bg-blue-50 border-blue-100 text-blue-600' : 'bg-white text-gray-600'}`}>
                <Filter size={16}/> Filters
            </button>
        </div>

        {showFilters && (
            <div className="p-4 bg-gray-50/50 border-t grid grid-cols-1 md:grid-cols-4 gap-4 animate-in slide-in-from-top-2">
                
                {/* Top Category SelectDropdown */}
                <SelectDropdown 
                  options={topCategories}
                  value={filters.topCategory}
                  labelKey="name"
                  valueKey="name"
                  placeholder="Top Category: All"
                  onChange={(val) => setFilters({...filters, topCategory: val, subCategory: ''})}
                  searchable
                  ChildClassName="!bg-white !text-xs !p-2.5 !border-gray-200"
                />

                {/* Sub Category SelectDropdown */}
                <SelectDropdown 
                  options={filteredSubOptions}
                  value={filters.subCategory}
                  labelKey="name"
                  valueKey="name"
                  placeholder="Sub Category: All"
                  disabled={!filters.topCategory}
                  onChange={(val) => setFilters({...filters, subCategory: val})}
                  searchable
                  ChildClassName="!bg-white !text-xs !p-2.5 !border-gray-200"
                />

                {/* Status SelectDropdown */}
                <SelectDropdown 
                  options={statusOptions}
                  value={filters.status}
                  placeholder="Status: All"
                  onChange={(val) => setFilters({...filters, status: val})}
                  ChildClassName="!bg-white !text-xs !p-2.5 !border-gray-200"
                />

                <button onClick={() => setFilters({topCategory:'', subCategory:'', status:'', stockStatus:''})} className="text-xs font-bold text-red-500 hover:bg-red-50 rounded-xl transition-all">Reset Filters</button>
            </div>
        )}
      </div>

      {/* Table Section */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
                <thead className="bg-blue-600 border-b text-white font-bold uppercase text-[10px] tracking-widest">
                    <tr>
                        <th className="px-6 py-5">Product Details</th>
                        <th className="px-6 py-5">Category Information</th>
                        <th className="px-6 py-5">Inventory</th>
                        <th className="px-6 py-5">Status</th>
                        <th className="px-6 py-5 text-center">Actions</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                    {paginatedData.map((product, idx) => (
                        <tr key={product._id + idx} className="hover:bg-gray-50/50 transition-colors group">
                            <td className="px-6 py-4">
                                <div className="flex items-center gap-4">
                                    <div className="h-14 w-14 rounded-xl bg-gray-100 overflow-hidden border border-gray-100 flex-shrink-0">
                                        <img src={product.previewImage || 'https://via.placeholder.com/100?text=No+Image'} alt="" className="h-full w-full object-cover" />
                                    </div>
                                    <div className="min-w-0">
                                        <div className="font-bold text-gray-900 truncate max-w-[180px]">{product.productName || "Untitled"}</div>
                                        <div className="text-[10px] text-gray-400 font-bold uppercase tracking-tight mt-0.5">{product.variantCount || 0} Colors • {product.brand || 'Generic'}</div>
                                    </div>
                                </div>
                            </td>
                            <td className="px-6 py-4">
                                <div className="text-gray-900 font-semibold">{product.topCategory?.name || product.topCategory || '-'}</div>
                                <div className="text-xs text-gray-400 mt-0.5">{product.subCategory?.name || product.subCategory || '-'}</div>
                            </td>
                            <td className="px-6 py-4">
                                <div className="text-gray-900 font-bold text-lg">{product.totalStock ?? 0}</div>
                                <div className="text-[9px] text-gray-400 font-black uppercase tracking-widest">Items Total</div>
                            </td>
                            <td className="px-6 py-4">
                                <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border ${product.status === 'Published' ? 'bg-green-50 text-green-600 border-green-100' : 'bg-gray-50 text-gray-500 border-gray-100'}`}>
                                    <span className={`h-1.5 w-1.5 rounded-full ${product.status === 'Published' ? 'bg-green-500' : 'bg-gray-400'}`}></span>
                                    {product.status || 'Draft'}
                                </span>
                            </td>
                            <td className="px-6 py-4 text-center">
                                <button onClick={(e) => handleOpenMenu(e, product)} className="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-400 group-hover:text-gray-900">
                                    <MoreHorizontal size={20} />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>

        <div className="p-6 border-t bg-gray-50/30">
            <Pagination 
              totalItems={filteredData.length} 
              itemsPerPage={itemsPerPage} 
              currentPage={currentPage} 
              onPageChange={(page) => setCurrentPage(page)} 
            />
        </div>
      </div>

      {/* Floating Menu */}
      {menuConfig.isOpen && (
        <div 
            ref={dropdownRef}
            className="fixed z-[9999] w-44 bg-white border border-gray-100 rounded-2xl shadow-2xl py-2 animate-in fade-in zoom-in-95 duration-150"
            style={{ top: `${menuConfig.top}px`, left: `${menuConfig.left}px` }}
        >
            <button 
                onClick={() => {
                  setMenuConfig(prev => ({ ...prev, isOpen: false }));
                  navigate(`upload/${menuConfig.productId}`, { state: { topCategories, subCategories, readOnly: true } });
                }}
                className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-600 hover:bg-gray-50 font-medium"
            >
                <Eye size={16} className="text-gray-400"/> View Details
            </button>
            <button 
                onClick={() => {
                  setMenuConfig(prev => ({ ...prev, isOpen: false }));
                  navigate(`upload/${menuConfig.productId}`, { state: { topCategories, subCategories, readOnly: false } });
                }}
                className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-600 hover:bg-gray-50 font-medium"
            >
                <Edit size={16} className="text-gray-400"/> Edit Product
            </button>
            <div className="h-px bg-gray-50 my-1 mx-2"></div>
            <button onClick={() => handleDelete(menuConfig.productId)} className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 font-bold">
                <Trash2 size={16}/> Delete Item
            </button>
        </div>
      )}
    </div>
  );
};

export default AllProducts;